import CountryLanding from "@/components/country/CountryLanding";
import { URUGUAY } from "@/data/countryPages";

export default function EOSUruguay() {
  return <CountryLanding country={URUGUAY} />;
}
